/**
 *   Docutain SDK Capacitor
 *   Copyright (c) INFOSOFT Informations- und Dokumentationssysteme GmbH. All rights reserved.
 *
 *   Docutain SDK Capacitor is a commercial product and requires a license.
 *   Details found in the LICENSE file in the root directory of this source tree.
 */
import { WebPlugin } from '@capacitor/core';
export class DocutainSDKWeb extends WebPlugin {
    /**
     * Initializes the Docutain SDK.
     * This method needs to be called prior to using any functionality of the Docutain SDK.
     * @param licenseKey your Docutain SDK license key.
     * @return true if initialization was successful, false otherwise. Use getLastError() to retrieve error message.
     */
    async initSDK(args) {
        console.log('initSDK from Web', args);
        throw ("not supported on web");
    }
    /**
     * Starts the document scanner.
     */
    async scanDocument(args) {
        console.log('scanDocument from Web', args);
        return { status: 'CANCELED' };
    }
    /**
     * This method is used to create a searchable PDF (includes text), or get the detected data or text of the imported file.
     *
     * @return true if the document was loaded successful, false otherwise.
     */
    async loadFile(args) {
        console.log('loadFile from Web', args);
    }
    /**
     * Detects the text of the currently loaded document and returns it.
     *
     * @return the detected text
     */
    async getText() {
        console.log('getText from Web');
        return { text: 'getText from Web' };
    }
    /**
     * Detects the text of the currently loaded document and returns it.
     *
     * @param pageNumber number of the page you want the text from or leave empty to get text of entire document
     * @return the detected text
     */
    async getTextPage(args) {
        console.log('getTextPage from Web', args.pageNumber);
        return { text: 'getTextPage from Web' };
    }
    /**
     * This method sets the analyze configuration.
     *
     * @param analyzeConfiguration An instance of AnalyzeConfiguration.
     * @return true if configuration was successful, false otherwise.
     */
    async setAnalyzeConfiguration(args) {
        console.log('setAnalyzeConfiguration from Web', args.config);
    }
    /**
     * Analyzes the currently loaded document and returns the detected data.
     *
     * @return the detected data as JSON String
     */
    async analyze() {
        console.log('analyze from Web');
        return { data: 'analyze from Web' };
    }
    /**
     * This method generates a PDF document from the loaded or scanned pages.
     *
     * @param filePath the file path where to save the PDF document.
     * @param overwrite if file already exist, indicate whether to override it or to append number, e.g. TestPDF(1).pdf.
     * @param PDF_PageFormat the PDF page format, refer to PDFPageFormat.
     * @return the file path if PDF document was generated successfully, null otherwise.
     */
    async writePDF(args) {
        console.log('writePDF from Web', args);
        return { fileUri: 'writePDF from Web' };
    }
    /**
     * This method sets the log level, which determines the severity of the message.
     *
     * @param logLevel The Level determining which kind of messages should be logged. The default is Level.VERBOSE.
     *
     */
    async setLogLevel(args) {
        console.log('setLogLevel from Web', args.logLevel);
    }
    /**
     * This method returns the Trace file which includes logging and error messages.
     *
     * @return the path to the Trace file.
     */
    async getTraceFile() {
        console.log('getTraceFile from Web');
        return { fileUri: 'getTraceFile from Web' };
    }
    /**
     * This method deletes all temporary files created by the Docutain SDK.
     *
     * @param deleteTraceFileContent If true, the content of the Trace file which you can send us in order to solve any problems will also be deleted
     *
     * @return true if all files deleted successfully, false if an error occurred
     */
    async deleteTempFiles(args) {
        console.log('deleteTempFiles from Web', args.deleteTraceFileContent);
    }
    /**
     * This method generates a JPG from the loaded or scanned page and saves it to a local file.
     *
     * @param pageNumber the page to be generated as JPG
     * @param filePath the file path where to save the JPG file
     * @return the file path if JPG was generated successfully, null otherwise
     */
    async writeImage(args) {
        console.log('writeImage from Web', args);
        return { fileUri: 'writeImage from Web' };
    }
    /**
     * This method generates a JPG from the loaded or scanned page and returns it as a base64 encoded string.
     *
     * @param pageNumber the page to be generated as JPG
     * @param pageSourceType the PageSourceType type to be used when generating the JPG
     * @return the base64 encoded string if JPG was generated successfully, null otherwise
     */
    async getImageBytes(args) {
        console.log('getImageBytes from Web', args);
        return { bytes: 'getImageBytes from Web' };
    }
    /**
     * This method returns the page count of the currently loaded document.
     *
     * @return page count of the currently loaded document.
     */
    async pageCount() {
        console.log('pageCount from Web');
        return { count: 0 };
    }
}
//# sourceMappingURL=web.js.map